import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=df5efd9a&scoped=true&"
import script from "./form-checkbox.vue?vue&type=script&lang=ts&"
export * from "./form-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=df5efd9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5efd9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol})
